/** Row field the grid groups by. MGA rows come from the list API; Placeholder rows come from the placeholder goals list. */
export const MGA_SALES_GOALS_GROUP_FIELD = 'listGroup';
export const MGA_SALES_GOALS_MGA_GROUP = 'MGA';
export const MGA_SALES_GOALS_PLACEHOLDER_GROUP = 'Placeholder';
export const MGA_SALES_GOALS_MGA_GROUP_LABEL = 'Registered MGAs';
export const MGA_SALES_GOALS_PLACEHOLDER_GROUP_LABEL = 'Prospective MGAs';
export const MGA_SALES_GOALS_OVERALL_GOAL_LABEL = 'Overall Goal';

export type MgaSalesGoalsGroup = typeof MGA_SALES_GOALS_MGA_GROUP | typeof MGA_SALES_GOALS_PLACEHOLDER_GROUP;

export const getMgaSalesGoalsGroupLabel = (value: unknown): string => {
  if (value === MGA_SALES_GOALS_MGA_GROUP) {
    return MGA_SALES_GOALS_MGA_GROUP_LABEL;
  }

  if (value === MGA_SALES_GOALS_PLACEHOLDER_GROUP) {
    return MGA_SALES_GOALS_PLACEHOLDER_GROUP_LABEL;
  }

  return String(value ?? '');
};
